import { afterNextRender, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { LANGUAGE } from '@valk-nx/core/lib/core';
import { GoogleTagManagerService } from '@valk-nx/services/google-tag-manager/src/lib/google-tag-manager.service';
import { SbWrapperComponent } from '@valk-nx/storyblok/components/wrapper/src/lib/wrapper.component';

@Component({
	selector: 'valk-content-root',
	templateUrl: './app.component.html',
	imports: [RouterOutlet, SbWrapperComponent],
})
export class AppComponent {
	private readonly translate = inject(TranslateService);
	private readonly language = inject(LANGUAGE);
	private readonly gtmService = inject(GoogleTagManagerService);

	constructor() {
		this.translate.setFallbackLang(this.language);
		this.translate.use(this.language);

		afterNextRender(() => this.gtmService.init());
	}
}
